import { render, staticRenderFns } from "./PayrollAccountsModal.vue?vue&type=template&id=5bf04a66&scoped=true"
import script from "./PayrollAccountsModal.vue?vue&type=script&lang=js"
export * from "./PayrollAccountsModal.vue?vue&type=script&lang=js"
import style0 from "./PayrollAccountsModal.vue?vue&type=style&index=0&id=5bf04a66&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bf04a66",
  null
  
)

export default component.exports